import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { apiClient } from '../../lib/apiClient'
import type { ApiResponse } from '../../types'
import type { Appointment } from '../appointments/appointment.types'
import Panel from '../../components/cards/Panel'
type Summary = {
  currency: string
  next_appointment: Appointment | null
  monthly_revenue: { month: string; net: number }[]
  mode_summary: { consultation_mode: string; total: number }[]
  recent_payments: {
    id: number
    amount: string
    currency: string
    status: string
  }[]
}
export default function DashboardExtras({
  role,
}: {
  role: 'admin' | 'doctor' | 'patient'
}) {
  const q = useQuery({
    queryKey: [role, 'dashboard'],
    queryFn: async () =>
      (await apiClient.get<ApiResponse<Summary>>('/' + role + '/dashboard'))
        .data.data,
  })
  if (!q.data) return null
  const data = q.data,
    next = data.next_appointment
  return (
    <div className="page-container pt-0">
      <Panel title="Next appointment">
        {next ? (
          <Link to={`/${role}/appointments/${next.id}`}>
            {next.appointment_no} · {next.appointment_date} {next.start_time}
          </Link>
        ) : (
          <p>No upcoming appointments.</p>
        )}
      </Panel>
      {role !== 'patient' && (
        <Panel
          className="mt-3"
          title={`Monthly net revenue (${data.currency})`}
        >
          <p>Refunds are deducted from the original payment month.</p>
          {data.monthly_revenue.map((m) => (
            <div className="mb-2" key={m.month}>
              <span>
                {m.month}: {m.net.toFixed(2)}
              </span>
              <progress
                className="d-block w-100"
                value={m.net}
                max={Math.max(1, ...data.monthly_revenue.map((x) => x.net))}
              />
            </div>
          ))}
        </Panel>
      )}
      <Panel className="mt-3" title="Consultation modes">
        {data.mode_summary.length ? (
          data.mode_summary.map((m) => (
            <p key={m.consultation_mode}>
              {m.consultation_mode.replaceAll('_', ' ')}: {m.total}
            </p>
          ))
        ) : (
          <p>No appointments yet.</p>
        )}
      </Panel>
      <Panel className="mt-3" title="Recent payments">
        {data.recent_payments.length ? (
          data.recent_payments.map((p) => (
            <p key={p.id}>
              #{p.id} · {p.currency} {p.amount} · {p.status}
            </p>
          ))
        ) : (
          <p>No payments yet.</p>
        )}
      </Panel>
    </div>
  )
}
